import triggerscrollto from './_triggerscrollto'

export default Vue => {
  Vue.directive('triggerscrollto', triggerscrollto)
}
